// src/pages/Help.jsx
import {SparklesIcon} from "@heroicons/react/24/outline";
import SEO from "../components/SEO.jsx";
import {Link} from "react-router-dom";
import React from "react";

export function Help() {
    return (
        <>
            <SEO
                title="Help Center - PostMgr Support"
                description="Get help with PostMgr including FAQs, tutorials, and troubleshooting guides."
                url="https://postmgr.com/help"
            />

            <div className="min-h-screen bg-gray-50">
                <nav className="bg-white shadow-sm">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="flex justify-between h-16">
                            <div className="flex items-center">
                                <Link to="/" className="flex items-center">
                                    <img src="/images/Bob_only.svg" alt="PostMgr" className="h-8 w-8" />
                                    <span className="ml-2 text-2xl font-bold text-blue-600">PostMgr</span>
                                </Link>
                            </div>
                            <div className="flex items-center space-x-4">
                                <Link to="/login" className="text-gray-700 hover:text-blue-600">Sign In</Link>
                                <Link to="/register" className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Get Started</Link>
                            </div>
                        </div>
                    </div>
                </nav>

                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">Help Center</h1>
                        <p className="text-xl text-gray-600">Find answers to common questions and get support</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm p-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-6">Frequently Asked Questions</h2>

                        <div className="space-y-6">
                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">How do I connect my social media accounts?</h3>
                                <p className="text-gray-600">Go to Settings -> Credentials and add your API keys for each platform you want to use.</p>
                            </div>

                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">Can I edit AI-generated posts before publishing?</h3>
                                <p className="text-gray-600">Yes! All posts require approval before publishing, and you can edit the content, choose different image variants, or regenerate entirely.</p>
                            </div>

                            <div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2">What if I reach my monthly post limit?</h3>
                                <p className="text-gray-600">You can upgrade your plan at any time from the Billing page, or wait until the next month for your limits to reset.</p>
                            </div>
                        </div>

                        <div className="mt-8 p-6 bg-blue-50 rounded-lg">
                            <h3 className="text-lg font-semibold text-blue-900 mb-2">Need More Help?</h3>
                            <p className="text-blue-800 mb-4">Can't find what you're looking for? Our support team is here to help.</p>
                            <Link to="/contact" className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                                Contact Support
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Help;
